import React from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../components/global/ProtectedRoute';
import PagesList from '../pages/pages_cms/PagesList';
import CreatePage from '../pages/pages_cms/CreatePage';
import EditPage from '../pages/pages_cms/EditPage';

const pagesRoutes = (
    <>
        {/* Pages List */}
        <Route
            path="/pages"
            element={
                <ProtectedRoute requiredPermission="cms.manage">
                    <PagesList />
                </ProtectedRoute>
            }
        />

        {/* Create Page */}
        <Route
            path="/pages/create"
            element={
                <ProtectedRoute requiredPermission="cms.manage">
                    <CreatePage />
                </ProtectedRoute>
            }
        />

        {/* Edit Page */}
        <Route
            path="/pages/:id/edit"
            element={
                <ProtectedRoute requiredPermission="cms.manage">
                    <EditPage />
                </ProtectedRoute>
            }
        />
    </>
);

export default pagesRoutes;
